import { render, staticRenderFns } from "./welcome.vue.html?vue&type=template&id=3377276a&scoped=true&"
import script from "./welcome.ts?vue&type=script&lang=ts&"
export * from "./welcome.ts?vue&type=script&lang=ts&"
import style0 from "./welcome.vue?vue&type=style&index=0&id=3377276a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3377276a",
  null
  
)

export default component.exports